// extracted by mini-css-extract-plugin
module.exports = {"selectContainer":"styles_selectContainer__X45C_ flex flex-column items-start justify-start","label":"styles_label__1p5rS lato","select":"styles_select__3wAco lato"};